import Modal from "react-bootstrap/Modal";
import { BsXCircle } from "react-icons/bs";
import RejectTimesheet from "../components/RejectTimesheet";

const RejectTimesheetModal = ({
  visible,
  close,
  shift,
  updateShift,
  cancelAction,
}) => {
  return (
    <Modal
      show={visible}
      onHide={close}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={"text-capitalize"}
        >
          <h1 className={"text-axis-offblack icon-text-wrapper"}>
            <BsXCircle className={"icon-right-spacing"} />
            Reject Timesheet
          </h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <RejectTimesheet
          shift={shift}
          onComplete={(s) => {
            updateShift(s);
            close();
          }}
          close={close}
        />
      </Modal.Body>
    </Modal>
  );
};

export default RejectTimesheetModal;
